module.exports = __webpack_public_path__ + "img/libra-ic.d18f6aae.png";